import axios from 'axios'
import router from '@/router'

const service = axios.create({
    //baseURL: BASE_URL
});

service.interceptors.request.use(
    config => {
        var urlList = config.url.split('/')
        var url = urlList[urlList.length - 1]
        if (url.indexOf('?') != -1) {
            url = url.split('?')[0]
        }
        if (config.url.indexOf('api') != -1) {
            var url2 = config.url.split('api')[1]
            if (url2.indexOf('?') != -1) {
                url2 = url2.split('?')[0]
            }
        }
        if (url == 'GetWeightNew' || url == 'GetRemindMessage' || url == 'rtspToPlayViewUrl' || url == ' GetNewUnReadAlarmCount' || url == 'CheckHeart' || url2 == '/ProduceMgr/DispatchTaskPrint/SX') {
            config.headers["invokeType"] = 'timer';
        }
        // console.log('object', config, url);
        config.headers["loginKey"] = StarSoft.LoginKey;
        config.headers["Content-Type"] = 'application/json; charset=utf-8';
        config.headers["ip"] = window.ip || localStorage.getItem('Ip');
        // && !config.params
        if (!config.data) {
            config.data = true
        }
        return config;
    },
    err => {
        return Promise.reject(err);
    }
);

service.interceptors.response.use(
    response => {
        var url = response.request.responseURL
        var isok = url.indexOf('MC6/api/Admin/User/GetUserSet') == -1 && url.indexOf('MC6/api/User/PowerData/GetPowerOpt') == -1
        // console.log(location.href);
        if (location.href.indexOf('LED') != -1) {
            isok = false
        }
        if (location.href.indexOf('ShowClientWeb') != -1) {
            isok = false
        }
        if (location.href.indexOf('StirPage') != -1) {
            isok = false
        }
        if (location.href.indexOf('FrontServiceMgr') != -1) {
            isok = false
        }
        if (location.href.indexOf('FrontServiceConfig') != -1) {
            isok = false
        }
        if (location.href.indexOf('LookEvidence') != -1) {
            isok = false
        }
        if (location.href.indexOf('carInfo') != -1) {
            isok = false
        }
        if (location.href.indexOf('repair') != -1) {
            isok = false
        }
        if (location.href.indexOf('onepage') != -1) {
            isok = false
        }
        if (location.href.indexOf('noTop') != -1) {
            isok = false
        }
        if (!response.data.Suc && response.data.ErrCode == 5001 && isok) {
            $message("会话超时,请重新登陆", "error");
            setTimeout(() => {
                setTimeout(() => {
                    if (StarSoft.ShowLeftRightID) {
                        StarSoft.LoginKey = null;
                        StarSoft.V8LoginKey = null;
                        location.href = "/timeOut";
                    } else {
                        fClearLoginCatch();
                        // location.href = "/";
                        location.href = location.origin + location.pathname + '#/login';
                    }
                }, 500);
                router.push('#/login')
            }, StarSoft.SysInfo.SysTimeOut ? StarSoft.SysInfo.SysTimeOut * 1000 : 5000)
        }
        return response;
    },
    error => {
        if (error.response) {
            switch (error.response.status) {
                case 401:
                    router.replace({
                        path: "/path",
                        query: { redirect: router.currentRoute.fullPath }
                    });
            }
        }

        $message(error.response.data.info, "error"); //xzz 20190805
        return Promise.reject(error.response.data);
    }
);

export default service;
